import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, NgControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'intelli-datepicker',
  templateUrl: './intelli-datepicker.component.html',
  styleUrls: ['./intelli-datepicker.component.css'],
  providers: [
     DatePipe,
    { provide: MatFormFieldControl, useExisting: IntelliDatepickerComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class IntelliDatepickerComponent implements MatFormFieldControl<Date>,ControlValueAccessor {


  _timezone: number = -3;
  private onChange: (value: Date) => void;

  private _date:Date;

  public changeDate()
  {
    this.onChange(this.value);
  }

  writeValue(obj: Date): void {
    
    console.log(" writeValue(obj");

    console.log(obj)
    this.value = obj;
  }
   registerOnChange(onChange: (value: Date) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if(isDisabled)
    {
      this.parts.get("textDate").disable();
    }
    else
    {
      this.parts.get("textDate").enable();
    }
  }

  public datemask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/];
  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'intelli-datepicker';
  id = `intelli-datepicker-${IntelliDatepickerComponent.nextId++}`;
  describedBy = '';

  get empty() {
    const { value: { textDate } } = this.parts;

    // console.log("empty:" + dateText + !dateText);
    return !textDate;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }


  @Input()
  get timezone(): number { return this._timezone; }
  set timezone(value: number) {
    this._timezone = value;
    this.stateChanges.next();
  }


  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): Date | null {

  return this._date;
  
    // }

    // return new Date();
  }

  set value(value: Date | null) {

    
    this._date = value;

    this.updateGui();

    //const  date  = value || new Date();
    // const { textDate } = tel || new Date();
    
  
  }

  public updateGui()
  {
    this.parts.setValue({ textDate:this.datePipe.transform(this.value, 'dd/MM/yyyy HH:mm') });      
    this.stateChanges.next();
  }

  public updateData()
  {
    const { value: { textDate } } = this.parts

  let strDate:string = textDate;

    if (strDate.length >= 16) {


      let day: string = strDate.substring(0, 2);
      let month: string = strDate.substring(3, 5);
      let year: string = strDate.substring(6, 10);
      let hour: string = strDate.substring(11, 13);
      let minute: string = strDate.substring(14, 16);

      strDate = `${year}-${month}-${day}T${hour}:${minute}`

      let date  =new Date  (  (new Date(Date.parse(strDate)).getTime()  + (this.timezone*60*60*1000))) ;

      this._date = date;
    }
  }

  constructor(@Optional() @Self() public ngControl: NgControl,private datePipe: DatePipe,fb: UntypedFormBuilder, private fm: FocusMonitor, private elRef: ElementRef<HTMLElement>) {
    
    // Setting the value accessor directly (instead of using
  // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }
    
    this.parts = fb.group({
      textDate: this.datePipe.transform(new Date(), 'dd/MM/yyyy HH:mm')
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });

    this.parts.valueChanges.subscribe(()=>
    {
         this.updateData();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }
}